import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * An abstract base class for API services.
 * It handles the HttpClient injection and constructs a base URL from the environment
 * and a provided resource path.
 */
@Injectable()
export abstract class BaseApiService {
  protected _baseUrl: string;

  /**
   * @param _http The HttpClient instance.
   * @param resourcePath The specific path for the API resource (e.g., '/agents').
   */
  protected constructor(protected _http: HttpClient, resourcePath: string) {
    this._baseUrl = `${environment.apiUrl}/${resourcePath}`;
  }
}
